
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 35 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.777 7.368a12.26 12.26 0 00-23.402 3.31 7.007 7.007 0 001.646 13.82 1.752 1.752 0 100-3.504 3.504 3.504 0 010-7.006 1.752 1.752 0 001.752-1.751 8.757 8.757 0 0113.249-7.5 8.758 8.758 0 013.795 4.68 1.75 1.75 0 001.366 1.174 5.256 5.256 0 01.42 10.228 1.755 1.755 0 00.876 3.398 8.759 8.759 0 004.841-13.624 8.758 8.758 0 00-4.543-3.225zm-10.002 3.625a1.75 1.75 0 00-.578-.367 1.752 1.752 0 00-1.331 0 1.75 1.75 0 00-.578.367l-5.255 5.255a1.759 1.759 0 102.487 2.487l2.26-2.277v9.79a1.751 1.751 0 103.503 0v-9.79l2.26 2.277a1.75 1.75 0 002.487 0 1.752 1.752 0 000-2.487l-5.255-5.255z"}})])
          )
        }
      }
    